(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // ==========================================================================
    // MicroModal
    // ==========================================================================
    const modalSwiper = new Swiper(".js-about-modal-slider", {
      loop: true,
      autoplay: {
        delay: 1800,
        disableOnInteraction: false,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1800,
      slidesPerView: 1,
      pagination: false,
      navigation: false,
    });

    MicroModal.init({
      disableScroll: true,
      disableFocus: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      onShow: (modal) => {
        modalSwiper.slideTo(0, 0);
        modalSwiper.update();
        setTimeout(() => {
          modalSwiper.autoplay.start();
        }, 600);

        // カレンダーモーダルは非表示時に Swiper を作るためコンテナ幅 0 で
        // breakpoints が誤適用される。表示直後に update() で再計算する。
        if (modal && modal.id === "js-modal-calendar" && typeof window.__refreshCalendarSwiper === "function") {
          window.__refreshCalendarSwiper();
        }
      },
      onClose: (modal) => {
        modalSwiper.slideTo(0, 0);
        modalSwiper.autoplay.stop();
      },
    });

    // ==========================================================================
    // SimpleBar
    // ==========================================================================
    Array.prototype.forEach.call(document.querySelectorAll(".js-simplebar"), (el) => new SimpleBar(el));

    // ==========================================================================
    // Guide Menu
    // ==========================================================================

    function setupGuideMenuObserver() {
      const header = document.getElementById("js-header");
      const guideMenu = document.getElementById("js-guide-menu");
      const guideMenuTargetGuide = document.getElementById("js-guide-menu-target-guide");
      const guideMenuTargetMv = document.getElementById("js-guide-menu-target-mv");

      let isGuideMenuTargetGuide = false;
      let useScrollFallback = false;

      let observerGuide = null;
      let observerMv = null;

      // ==== 表示状態を更新 ====
      function updateMenuState() {
        if (!guideMenu) return;

        // guideMenuTargetGuide が見えているときは非表示
        if (isGuideMenuTargetGuide) {
          guideMenu.classList.add("-hidden");
          guideMenu.classList.remove("-visible");
        } else {
          guideMenu.classList.add("-visible");
          guideMenu.classList.remove("-hidden");
        }

        // ヘッダーの状態制御
        if (useScrollFallback) {
          if (window.scrollY > 0) {
            header?.classList.add("-scrolled");
          } else {
            header?.classList.remove("-scrolled");
          }
        }
      }

      // ==== IntersectionObserver 初期化 ====
      function initObservers() {
        // guideMenuTargetGuide の監視（非表示制御のみ）
        if (guideMenuTargetGuide) {
          observerGuide = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                isGuideMenuTargetGuide = entry.isIntersecting;
                updateMenuState();
              });
            },
            { root: null, threshold: 0.1 },
          );
          observerGuide.observe(guideMenuTargetGuide);
        }

        // guideMenuTargetMv は常に表示状態維持（observer登録のみヘッダー制御用）
        if (guideMenuTargetMv) {
          observerMv = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const isMvVisible = entry.isIntersecting;
                if (isMvVisible) {
                  header?.classList.remove("-scrolled");
                } else {
                  header?.classList.add("-scrolled");
                }
              });
            },
            { threshold: 0.1 },
          );
          observerMv.observe(guideMenuTargetMv);
        } else {
          // fallback: スクロール時にヘッダー制御
          useScrollFallback = true;
          window.addEventListener("scroll", updateMenuState);
        }
      }

      // ==== 監視解除 ====
      function destroyObservers() {
        if (observerGuide && guideMenuTargetGuide) {
          observerGuide.unobserve(guideMenuTargetGuide);
          observerGuide.disconnect();
        }
        if (observerMv && guideMenuTargetMv) {
          observerMv.unobserve(guideMenuTargetMv);
          observerMv.disconnect();
        }
        if (useScrollFallback) {
          window.removeEventListener("scroll", updateMenuState);
        }
      }

      // 初期化
      initObservers();
      updateMenuState();

      return {
        destroy: destroyObservers,
      };
    }

    const guideMenuController = setupGuideMenuObserver();
    // 必要になったら guideMenuController.destroy(); を呼ぶ
    const accordionGuideDetails = ".js-guide-accordion";
    const accordionGuideSummary = ".js-guide-accordion-summary";
    const accordionGuideContent = ".js-guide-accordion-content";
    const closeButtonSel = ".js-guide-accordion-close";
    const accordionGuideSpeed = 0.3;

    document.querySelectorAll(accordionGuideSummary).forEach((summary) => {
      const details = summary.closest(accordionGuideDetails);
      const content = details?.querySelector(accordionGuideContent);
      if (!details || !content) return;

      // 初期状態で閉じる
      gsap.set(content, { height: 0, overflow: "hidden", display: "none" });

      // 開く処理
      const openAccordionGuide = () => {
        details.setAttribute("open", "true");
        content.style.display = "block";
        const fullHeight = content.scrollHeight;

        gsap.killTweensOf(content);
        gsap.fromTo(
          content,
          { height: 0, overflow: "hidden" },
          {
            height: fullHeight,
            duration: accordionGuideSpeed,
            ease: "power2.out",
            onStart: () => {
              // hint browser to optimize height animation
              content.style.willChange = "height";
            },
            onComplete: () => {
              content.style.height = "auto";
              content.style.overflow = "";
              content.style.willChange = "";
              gsap.set(content, { clearProps: "transform" });
            },
          },
        );
      };

      // close handler
      const closeAccordionGuide = () => {
        gsap.killTweensOf(content);
        const currentHeight = content.scrollHeight;

        gsap.fromTo(
          content,
          { height: currentHeight, overflow: "hidden" },
          {
            height: 0,
            duration: accordionGuideSpeed,
            ease: "power2.in",
            onStart: () => {
              // hint browser to optimize height animation
              content.style.willChange = "height";
            },
            onComplete: () => {
              details.removeAttribute("open");
              content.style.display = "none";
              content.style.height = "";
              content.style.overflow = "";
              content.style.willChange = "";
              gsap.set(content, { clearProps: "transform" });
            },
          },
        );
        summary.classList.remove("-active");
      };

      // サマリークリックでトグル
      summary.addEventListener("click", (event) => {
        event.preventDefault();
        const isOpen = details.hasAttribute("open");
        summary.classList.toggle("-active", !isOpen);
        isOpen ? closeAccordionGuide() : openAccordionGuide();
      });

      // 既存のクローズボタンのみイベント付与（自動追加はしない）
      content.querySelectorAll(closeButtonSel).forEach((btn) => {
        if (btn.dataset.bound === "1") return; // 二重付与防止
        btn.dataset.bound = "1";
        btn.setAttribute("type", btn.getAttribute("type") || "button");
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          if (details.hasAttribute("open")) closeAccordionGuide();
        });
      });

      // quick menu specific: open by default and auto-close on scroll
      const isQuickMenu = !!details.closest("#js-guide-menu");
      if (isQuickMenu) {
        // open initially
        summary.classList.add("-active");
        openAccordionGuide();

        // auto-close on first scroll intent; keep container visible
        const detachAutoClose = () => {
          window.removeEventListener("scroll", onScrollClose);
          window.removeEventListener("wheel", onIntentClose);
          window.removeEventListener("touchstart", onIntentClose);
          window.removeEventListener("touchmove", onIntentClose);
          window.removeEventListener("keydown", onKeyClose);
        };

        const triggerCloseOnce = () => {
          if (details.hasAttribute("open")) {
            closeAccordionGuide();
            detachAutoClose();
          }
        };

        const onScrollClose = () => {
          if (window.scrollY > 0) triggerCloseOnce();
        };

        const onIntentClose = () => triggerCloseOnce();

        const onKeyClose = (e) => {
          const k = e.code || e.key;
          if (k === "ArrowDown" || k === "PageDown" || k === "Space") {
            triggerCloseOnce();
          }
        };

        window.addEventListener("scroll", onScrollClose, { passive: true });
        window.addEventListener("wheel", onIntentClose, { passive: true });
        window.addEventListener("touchstart", onIntentClose, { passive: true });
        window.addEventListener("touchmove", onIntentClose, { passive: true });
        window.addEventListener("keydown", onKeyClose);
      }
    });

    // ==========================================================================
    // 印刷シンボルSVG対策
    // ==========================================================================
    function handleBeforePrint() {
      document.querySelectorAll("use").forEach((use) => {
        const href = use.getAttribute("href") || use.getAttribute("xlink:href");
        if (!href) return;

        const refId = href.replace("#", "");
        const symbol = document.getElementById(refId);
        if (symbol) {
          const svg = use.closest("svg");
          if (svg) {
            svg.innerHTML = symbol.innerHTML;
          }
        }
      });
    }

    // 登録
    window.addEventListener("beforeprint", handleBeforePrint);

    // 解除
    // window.removeEventListener("beforeprint", handleBeforePrint);
    // END

    // ==========================================================================
    // modal calendar
    // ==========================================================================
    const prevBtn = document.querySelector(".js-cal-prev");
    const nextBtn = document.querySelector(".js-cal-next");
    const monthEl = document.querySelector(".js-cal-month");
    const yearEl = document.querySelector(".js-cal-year");

    const wrapperEl = document.querySelector(".js-cal-wrapper");

    // 納期再計算: トリガーボタンの data-product-id / data-quantity-source を
    // モーダル(#js-modal-calendar)の data-* に転写し、選択日付を start_date として API に投げる。
    const calendarModalEl = document.getElementById("js-modal-calendar");
    const calResultStartEl = document.querySelector(".js-cal-result-start");
    const calResultDeliveryEl = document.querySelector(".js-cal-result-delivery");
    let calendarFetchAbort = null;

    function formatYmdToJa(ymd) {
      const [y, m, d] = ymd.split("-").map(Number);
      return `${y}年${m}月${d}日`;
    }

    window.onCalendarSelect = function (ymd) {
      if (calResultStartEl) calResultStartEl.textContent = formatYmdToJa(ymd);
      if (!calendarModalEl || !calResultDeliveryEl) return;

      const productId = calendarModalEl.dataset.productId;
      const endpoint = calendarModalEl.dataset.endpoint;
      if (!productId || !endpoint) return;

      const quantity = calendarModalEl.dataset.quantity || "1";

      if (calendarFetchAbort) calendarFetchAbort.abort();
      calendarFetchAbort = new AbortController();

      // マーキングを注文している商品は、その枚数ぶん納期が延びる（仕様書 v0.45 P3）。
      // 画面の納品予定日と同じ条件で引けるよう、カレンダーからも一緒に渡す
      const markingQuantity = parseInt(calendarModalEl.dataset.markingQuantity || "0", 10) || 0;
      const printType = calendarModalEl.dataset.printType || "";
      const markingParams =
        markingQuantity > 0 && printType !== ""
          ? `&marking_quantity=${encodeURIComponent(markingQuantity)}&print_type=${encodeURIComponent(printType)}`
          : "";

      const url = `${endpoint}?product_id=${encodeURIComponent(productId)}&quantity=${encodeURIComponent(quantity)}&start_date=${encodeURIComponent(ymd)}${markingParams}`;
      fetch(url, { signal: calendarFetchAbort.signal, headers: { Accept: "application/json" } })
        .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
        .then((data) => {
          calResultDeliveryEl.textContent = data.delivery_date_label || data.delivery_date || "-";
          if (data.start_date_label && calResultStartEl) {
            calResultStartEl.textContent = data.start_date_label;
          }
        })
        .catch((err) => {
          if (err.name === "AbortError") return;
          console.warn("delivery-date fetch failed:", err);
          calResultDeliveryEl.textContent = "-";
        });
    };

    let selectedYmd = "";
    let baseMonth = null;
    let swiper = null;

    function pad2(n) {
      return String(n).padStart(2, "0");
    }
    function toYmd(d) {
      return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    }
    function startOfDay(d) {
      const x = new Date(d);
      x.setHours(0, 0, 0, 0);
      return x;
    }
    function addDays(d, n) {
      const x = new Date(d);
      x.setDate(x.getDate() + n);
      return x;
    }
    function addMonths(monthStart, n) {
      return new Date(monthStart.getFullYear(), monthStart.getMonth() + n, 1);
    }
    function parseYmd(ymd) {
      const [y, m, d] = ymd.split("-").map(Number);
      return new Date(y, m - 1, d);
    }

    function minSelectableDate() {
      const now = new Date();
      const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);

      return new Date(jst.getUTCFullYear(), jst.getUTCMonth(), jst.getUTCDate());
    }

    function isSelected(d) {
      return selectedYmd && toYmd(d) === selectedYmd;
    }

    function setHeaderByIndex(activeIndex) {
      if (!monthEl || !yearEl || !baseMonth) return;
      const m = addMonths(baseMonth, activeIndex);
      monthEl.textContent = String(m.getMonth() + 1);
      yearEl.textContent = String(m.getFullYear());
    }

    function renderMonthHtml(monthStart) {
      const y = monthStart.getFullYear();
      const m = monthStart.getMonth();

      const first = new Date(y, m, 1);
      const firstDow = first.getDay();
      const start = new Date(y, m, 1 - firstDow);
      const minD = minSelectableDate();

      const daysInMonth = new Date(y, m + 1, 0).getDate();
      const cellsNeeded = firstDow + daysInMonth;
      const weeks = Math.ceil(cellsNeeded / 7);
      const totalCells = weeks * 7;

      let gridHtml = "";
      for (let i = 0; i < totalCells; i++) {
        const d = addDays(start, i);

        const inMonth = d.getMonth() === m;
        const disabled = startOfDay(d) < minD;
        const selected = isSelected(d);
        const dow = d.getDay();

        const cls = ["c-calendar__day", !inMonth ? "-other-month" : "", disabled ? "-disabled" : "", selected ? "-selected" : "", dow === 0 ? "-sun" : "", dow === 6 ? "-sat" : ""].filter(Boolean).join(" ");

        const ymd = toYmd(d);

        gridHtml += `
      <div class="${cls}">
        <button type="button" data-ymd="${ymd}" ${disabled ? "disabled" : ""} aria-label="${ymd}">
          ${d.getDate()}
        </button>
      </div>
    `;
      }

      return `
    <div class="c-calendar__header -in-slide">
      <div class="c-calendar__title">
        <div></div>
        <span class="c-calendar__month">${m + 1}</span>
        <span class="c-calendar__year">${y}</span>
      </div>
    </div>

    <div class="c-calendar__dow">
      <div class="-sun">sun</div><div>mon</div><div>tue</div><div>wed</div><div>thu</div><div>fri</div><div class="-sat">sat</div>
    </div>

    <div class="c-calendar__grid">${gridHtml}</div>
  `;
    }

    function attachDayHandlers() {
      wrapperEl.querySelectorAll("button[data-ymd]").forEach((btn) => {
        btn.addEventListener("click", () => {
          selectedYmd = btn.dataset.ymd;

          if (typeof window.onCalendarSelect === "function") {
            window.onCalendarSelect(selectedYmd);
          }

          renderSlides();
          initOrUpdateSwiper();
          if (swiper) setHeaderByIndex(swiper.activeIndex);
        });
      });
    }

    function renderSlides() {
      if (!baseMonth || !wrapperEl) return;

      const m0 = baseMonth;
      const m1 = addMonths(baseMonth, 1);
      const m2 = addMonths(baseMonth, 2);

      wrapperEl.innerHTML = `
    <div class="swiper-slide">${renderMonthHtml(m0)}</div>
    <div class="swiper-slide">${renderMonthHtml(m1)}</div>
    <div class="swiper-slide">${renderMonthHtml(m2)}</div>
  `;

      attachDayHandlers();
    }

    function updateNavButtons() {
      if (!swiper) return;
      if (prevBtn) prevBtn.disabled = swiper.isBeginning;
      if (nextBtn) nextBtn.disabled = swiper.isEnd;
    }

    function initOrUpdateSwiper() {
      if (typeof Swiper === "undefined") {
        console.error("Swiper is not loaded.");
        return;
      }

      const swiperRoot = document.querySelector(".js-cal-swiper");
      if (!swiperRoot || !wrapperEl) return;

      if (swiper) {
        swiper.update();
        updateNavButtons();
        return;
      }

      swiper = new Swiper(".js-cal-swiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        scrollbar: { el: ".swiper-scrollbar", draggable: true },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        on: {
          afterInit: (sw) => {
            updateNavButtons();
            setHeaderByIndex(sw.activeIndex);
          },
          slideChange: (sw) => {
            updateNavButtons();
            setHeaderByIndex(sw.activeIndex);
          },
          resize: (sw) => {
            updateNavButtons();
            setHeaderByIndex(sw.activeIndex);
          },
        },
      });

      if (!swiper || !swiper.slides || !swiper.slides.length) {
        swiper = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener("click", () => swiper && swiper.slidePrev());
    if (nextBtn) nextBtn.addEventListener("click", () => swiper && swiper.slideNext());

    (function init() {
      if (!wrapperEl) return;

      const minD = minSelectableDate();
      selectedYmd = toYmd(minD);
      const now = new Date();
      baseMonth = new Date(now.getFullYear(), now.getMonth(), 1);

      renderSlides();
      initOrUpdateSwiper();

      const selectedDate = startOfDay(parseYmd(selectedYmd));
      const selectedMonthStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      const diffMonths = (selectedMonthStart.getFullYear() - baseMonth.getFullYear()) * 12 + (selectedMonthStart.getMonth() - baseMonth.getMonth());
      const initialIndex = diffMonths >= 0 && diffMonths <= 2 ? diffMonths : 0;

      if (swiper && swiper.slides && swiper.slides.length) {
        swiper.slideTo(initialIndex, 0);
        setHeaderByIndex(initialIndex);
      } else {
        setHeaderByIndex(initialIndex);
      }
    })();

    // モーダル表示時に呼ばれ、display:none で width 0 のまま生成された Swiper の
    // スライド幅・breakpoints を再計算して PC で 3か月表示に戻す。
    window.__refreshCalendarSwiper = function () {
      if (!swiper) return;
      swiper.update();
      swiper.slideTo(0, 0);
      setHeaderByIndex(0);
    };

    // 各「任意日で納期確認」ボタンのクリックで、モーダル context (product_id / quantity) を更新し、
    // カレンダーを今日にリセットして初期 fetch を走らせる。
    document.querySelectorAll('[data-micromodal-trigger="js-modal-calendar"]').forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!calendarModalEl || !wrapperEl) return;

        const productId = btn.dataset.productId || "";
        calendarModalEl.dataset.productId = productId;

        let quantity = "1";
        if (btn.dataset.quantity) {
          const n = parseInt(btn.dataset.quantity, 10);
          if (n > 0) quantity = String(n);
        } else if (btn.dataset.quantitySource) {
          const el = document.querySelector(btn.dataset.quantitySource);
          if (el) {
            const n = parseInt((el.textContent || "").replace(/[^0-9]/g, ""), 10);
            if (n > 0) quantity = String(n);
          }
        }
        calendarModalEl.dataset.quantity = quantity;

        // マーキングの枚数とプリント方法。
        // 数量入力画面は入力しながら変わるので画面側の計算を使い、
        // 確認画面・仮注文書は確定済みの値をサーバーから受け取る
        let markingQuantity = 0;
        let printType = "";
        if (btn.dataset.markingQuantity !== undefined) {
          markingQuantity = parseInt(btn.dataset.markingQuantity, 10) || 0;
          printType = btn.dataset.printType || "";
        } else if (btn.dataset.order !== undefined && typeof markingDeliveryQuantityOf === "function") {
          // 納期用の枚数（数量未入力でも設定があれば最低ロット1着）
          const orderIndex = Number(btn.dataset.order);
          const customIndex = Number(btn.dataset.custom);
          markingQuantity = markingDeliveryQuantityOf(orderIndex, customIndex);
          printType = markingPrintTypeOf(orderIndex, customIndex);
        }
        calendarModalEl.dataset.markingQuantity = String(markingQuantity);
        calendarModalEl.dataset.printType = printType;

        // カレンダー状態を今日にリセット
        const minD = minSelectableDate();
        selectedYmd = toYmd(minD);
        const now = new Date();
        baseMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        renderSlides();
        initOrUpdateSwiper();
        if (swiper && swiper.slides && swiper.slides.length) {
          swiper.slideTo(0, 0);
        }
        setHeaderByIndex(0);

        // 今日基準で初期 fetch
        if (productId) {
          window.onCalendarSelect(selectedYmd);
        } else {
          if (calResultStartEl) calResultStartEl.textContent = formatYmdToJa(selectedYmd);
          if (calResultDeliveryEl) calResultDeliveryEl.textContent = "-";
        }
      });
    });

    // ==========================================================================
    // Delivery Calendar Page (/calendar)
    //
    // サーバ側 (WelcomeController::calendar) が 1ヶ月分のカレンダー HTML を吐く。
    // 当月 / 翌月 / 翌々月の 3ヶ月のみ表示できる。JS は:
    //   - 種別ボタン: hidden bi_code と filter dropdown の -active 切替
    //   - 前後月ボタン: month_offset (0-2) を更新して form 再送信
    //   - 日付セル内ボタンクリック: data-* を読んで #js-modal-deadline に差し込み
    //   - クイック検索: AJAX で /calendar/quick-search を叩き #js-modal-deadline-search に差し込み
    // ==========================================================================

    const calendarFilterForm = document.getElementById("calendar-filter-form");
    const calendarTypeButtons = document.querySelectorAll(".js-calendar-type-button");
    const calendarFilterBlocks = document.querySelectorAll(".js-calendar-filter");

    if (calendarFilterForm) {
      const biCodeInput = document.getElementById("calendar-filter-bi-code");

      // 種別 (FOOTBALL / RUNNING / TRAINING) ボタンクリックで即時にフォーム送信し、
      // カレンダーを切替える。タブ的な UI 期待値に合わせる。
      calendarTypeButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const biCode = btn.dataset.biCode;
          const targetId = btn.dataset.calendarType;

          calendarTypeButtons.forEach((b) => b.classList.remove("-selected"));
          btn.classList.add("-selected");

          if (biCodeInput) biCodeInput.value = biCode || "";

          // 全種別のカテゴリ select をクリア (種別変更時は条件リセット)
          calendarFilterBlocks.forEach((block) => {
            block.classList.remove("-active");
            block.querySelectorAll("select").forEach((s) => {
              s.selectedIndex = 0;
            });
          });
          const target = document.getElementById(targetId);
          if (target && target.classList.contains("js-calendar-filter")) {
            target.classList.add("-active");
          }

          calendarFilterForm.submit();
        });
      });
    }

    // 共通: HTML escape (calendar 関連で複数箇所から呼ぶ)
    function escapeHtmlText(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    }

    const deliveryCalendarRoot = document.querySelector(".js-delivery-calendar");
    if (deliveryCalendarRoot && calendarFilterForm) {
      const prevBtns = deliveryCalendarRoot.querySelectorAll(".js-delivery-cal-prev");
      const nextBtns = deliveryCalendarRoot.querySelectorAll(".js-delivery-cal-next");
      const monthOffsetInput = calendarFilterForm.querySelector('input[name="month_offset"]');

      const submitWithOffset = (delta) => {
        const current = parseInt(deliveryCalendarRoot.dataset.monthOffset || "0", 10);
        let next = current + delta;
        if (next < 0) next = 0;
        if (next > 2) next = 2;
        if (next === current) return;
        if (monthOffsetInput) monthOffsetInput.value = String(next);
        calendarFilterForm.submit();
      };

      prevBtns.forEach((btn) => btn.addEventListener("click", () => submitWithOffset(-1)));
      nextBtns.forEach((btn) => btn.addEventListener("click", () => submitWithOffset(+1)));

      // 日付セル内「カテゴリバッジ」クリック: 該当日の納期情報と商品リストをモーダルに差し込む
      const deadlineModal = document.getElementById("js-modal-deadline");
      const deadlineBadgeEl = deadlineModal && deadlineModal.querySelector(".js-modal-deadline-badge");
      const deadlineYearEl = deadlineModal && deadlineModal.querySelector(".js-modal-deadline-year");
      const deadlineMonthDayEl = deadlineModal && deadlineModal.querySelector(".js-modal-deadline-month-day");
      const deadlineProductsEl = deadlineModal && deadlineModal.querySelector(".js-modal-deadline-products");

      function renderDeadlineModal(payload) {
        if (!deadlineModal) return;
        if (deadlineBadgeEl) deadlineBadgeEl.textContent = payload.categoryNameEn || "-";

        const dateStr = payload.deliveryDate || "";
        const parts = dateStr.split(".");
        if (deadlineYearEl) deadlineYearEl.textContent = parts[0] || "----";
        if (deadlineMonthDayEl) {
          deadlineMonthDayEl.textContent = parts[1] && parts[2] ? `${parts[1]}.${parts[2]}` : "--.--";
        }

        if (deadlineProductsEl) {
          if (!payload.products || !payload.products.length) {
            deadlineProductsEl.innerHTML = '<p class="c-modal__deadline-text">該当する商品はありません。</p>';
          } else {
            deadlineProductsEl.innerHTML = payload.products
              .map(
                (p) =>
                  '<div class="c-modal__deadline-card">' +
                  '<p class="c-modal__deadline-card-label">' +
                  '<span class="c-modal__deadline-card-label-text">商品名</span>' +
                  `<span class="c-modal__deadline-card-label-value">${escapeHtmlText(p.product_name)}</span>` +
                  "</p>" +
                  '<p class="c-modal__deadline-card-label">' +
                  '<span class="c-modal__deadline-card-label-text">品番</span>' +
                  `<span class="c-modal__deadline-card-label-value">${escapeHtmlText(p.article_number)}</span>` +
                  "</p>" +
                  "</div>"
              )
              .join("");
          }
        }
      }

      deliveryCalendarRoot.addEventListener("click", (e) => {
        const btn = e.target.closest(".js-delivery-cal-info-button");
        if (!btn) return;
        const key = btn.dataset.categoryKey || "";
        const products = (window.__calendarProductsByCategory && window.__calendarProductsByCategory[key]) || [];
        renderDeadlineModal({
          categoryNameEn: btn.dataset.categoryNameEn || "",
          deliveryDate: btn.dataset.deliveryDate || "",
          products,
        });
      });
    }

    // クイック検索 (品番 → 本日発注時の納期)
    const quickSearchSection = document.querySelector("[data-quick-search-endpoint]");
    const quickSearchButton = document.querySelector(".js-quick-search-button");
    if (quickSearchSection && quickSearchButton) {
      const endpoint = quickSearchSection.dataset.quickSearchEndpoint;
      const csrfToken = quickSearchSection.dataset.csrfToken || "";
      const inputs = document.querySelectorAll(".js-quick-search-input");
      const resultsEl = document.querySelector(".js-modal-quick-search-results");

      function renderQuickResults(results) {
        if (!resultsEl) return;
        if (!results || !results.length) {
          resultsEl.innerHTML = '<p class="c-modal__deadline-text">該当する商品が見つかりませんでした。</p>';
          return;
        }
        resultsEl.innerHTML = results
          .map(
            (r) =>
              '<div class="c-modal__deadline-card">' +
              '<p class="c-modal__deadline-card-label">' +
              '<span class="c-modal__deadline-card-label-text">商品名</span>' +
              `<span class="c-modal__deadline-card-label-value">${escapeHtmlText(r.product_name)}</span>` +
              "</p>" +
              '<p class="c-modal__deadline-card-label">' +
              '<span class="c-modal__deadline-card-label-text">品番</span>' +
              `<span class="c-modal__deadline-card-label-value">${escapeHtmlText(r.article_number)}</span>` +
              "</p>" +
              '<div class="c-modal__deadline">' +
              '<p class="c-modal__deadline-text">本日発注した場合の納期</p>' +
              '<div class="c-modal__deadline-box">' +
              '<div class="c-modal__deadline-box-text01"></div>' +
              `<p class="c-modal__deadline-box-text02">${escapeHtmlText(r.delivery_date)}</p>` +
              '<p class="c-modal__deadline-box-text03">頃お届け</p>' +
              "</div>" +
              "</div>" +
              "</div>"
          )
          .join("");
      }

      quickSearchButton.addEventListener("click", () => {
        const payload = {};
        inputs.forEach((el) => {
          const v = (el.value || "").trim();
          if (v) payload[el.name] = v;
        });

        if (resultsEl) resultsEl.innerHTML = '<p class="c-modal__deadline-text">検索中...</p>';

        fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-TOKEN": csrfToken,
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        })
          .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
          .then((data) => renderQuickResults(data))
          .catch((err) => {
            console.warn("quick-search failed:", err);
            if (resultsEl) {
              resultsEl.innerHTML = '<p class="c-modal__deadline-text">検索に失敗しました。</p>';
            }
          });
      });
    }
  });
})();
